<template>
    <div class="buyCarPart">
        <div class="buyCar_item">
            <div class="selectCircle" :class="{beSelectCircle : goodsInfo.selected}" @click="handleSelectedFunc()"></div>
            <div class="product_img">
                <img :src="this.weburl + goodsInfo.goods.original_img" alt="">
            </div>
            <div class="product_detail">
                <h3>{{goodsInfo.goods_name}}</h3>
                <p>使用时间：{{handleUseTimeFormat(goodsInfo.occ_date)}}</p>
                <span class="price">￥{{parseFloat(goodsInfo.goods_price)*goodsInfo.goods_num}}</span>
                <div class="buy_num"><span @click="addNum(goodsInfo.id)">+</span><input type="text" v-model="buyNum" @blur="btnBlur()"><span @click="delNum(goodsInfo.id)">-</span></div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Toast } from 'mint-ui';
    export default {
        name: "buyCarPart",
        props:["goodsInfo"],
        data: function () {
            return {
                buyNum:"",                                   //购买的数量
                cart_id:"",                                  //该条购物车商品的id
                selected:"",                                 //该条购物车商品的选中状态
            }
        },
        created: function () {
            // console.log(this.goodsInfo);
            this.buyNum = this.goodsInfo.goods_num;
            this.cart_id = this.goodsInfo.id;
            this.selected = this.goodsInfo.selected;
        },
        computed: {
            weburl: function () {
                return this.$store.state.weburl;
            },
            hurl: function () {
                return this.$store.state.hurl;
            }
        },
        methods: {
            handleUseTimeFormat: function (time) {
                var formatTime = new Date(time*1000);
                var formatTimeY = formatTime.getFullYear();
                var formatTimeM = formatTime.getMonth()+1;
                var formatTimeD = formatTime.getDate();
                formatTime = formatTimeY + "-" + formatTimeM + "-" + formatTimeD;
                return formatTime;
            },
            addNum: function (id) {
                this.buyNum += 1;
                this.sendNum();
            },
            delNum: function (id) {
                this.buyNum -= 1;
                if(this.buyNum < 1){
                    Toast("购买数量不能小于1");
                    this.buyNum = 1;
                }
                this.sendNum();

            },
            // 向服务器发送请求修改该条商品的数量
            sendNum: function () {
                this.$http({
                xhrFields: {
                    withCredentials: true
                },
                crossDomain: true,
                method: "post",
                url: this.weburl + this.hurl + "/Cart/changeNum",
                dataType:"json",
                data:{
                    cart:{
                        id:this.cart_id,
                        goods_num:this.buyNum
                    }
                }
                })
                .then( res => {
                    console.log(res);
                })
                .catch( err => {
                    console.log(err);
                })
            },
            btnBlur: function () {
                if(this.buyNum < 1 || !this.buyNum){
                    Toast("购买数量不能小于1");
                    this.buyNum = 1;
                }
                this.sendNum();
            },
            handleSelectedFunc: function () {
                if(!this.selected){
                    this.selected = 1;
                }else{
                    this.selected = 0;
                }
                let obj = {};
                obj.id = this.cart_id;
                obj.goods_num = this.buyNum;
                obj.selected = this.selected;
                this.$emit("changeSelectedStatus",obj);
            }
        },

    }
</script>

<style scoped lang="less">
    @import '../../assets/less/common.less';
    .buyCarPart {
        width: @width;
        padding: 0.5rem ;
        .box-sizing;
        .buyCar_item {
            height: 75px;
            width: @width;
            .box-sizing;
            padding-left: 7%;
            position: relative;
            .product_img {
                float: left;
                width: 30%;
                height: 100%;
                img{
                    .img;

                }
            }
            .product_detail {
                float: right;
                width: 67%;
                height: 100%;
                position: relative;
                h3 {
                    font-size:@font - .1;
                    margin-bottom: 4px;
                }
                p{
                    color:@word;
                    font-size:@font - .4;
                }
                .price{
                    position: absolute;
                    bottom:0;
                    left:0;
                    color:@subject_color;

                }



            }



        }
    }
    &.buy_num span ,&.buy_num input {
        float: right;
        display: inline-block;
        width: 25px;
        height: 25px;
        text-align: center;
        line-height: 25px;
        font-size:@font + .2;
        margin-top: 5px;
        border-radius: 4px;
    }
    &.buy_num span{
        color:#fff;
        background:  @word;
    }
    &.buy_num input {
        border: 1px solid @word;
        margin:5px 5px 0 5px;
        .box-sizing;
    }
    .selectCircle{
        content: '';
        width:@font;
        top: 24px;
        left: 1%;
        .border-radius(50%);
        .border(1px;solid;@word);
        height: @font;
        position: absolute;
    }
    .beSelectCircle{
        background: url("@{sprite}") no-repeat -197px -16px;
        background-size: 238px auto;
    }

</style>
